export default __webpack_public_path__ + "static/media/surveyGreen.93229a6e.png";